module.exports = __webpack_public_path__ + "img/ic_error.ef713906.svg";